export const FORM_IDS = {
  WELCOME_MESSAGE_CONFIGURATION: 'welcome_message_configuration',
  QUESTIONS: 'questions',
  RESPONSE_LINE_CONFIGURATION: 'response_line_configuration',
  ILLEGAL_RESPONSE_TEXT_CONFIGURATION: 'illegal_response_text_configuration',
  ENDING_MESSAGE_CONFIGURATION: 'ending_message_configuration',
} as const;
